import {
  type Dispatch,
  type FC,
  type PropsWithChildren,
  type SetStateAction,
  createContext,
  useContext,
  useState,
} from 'react';
import type z from 'zod';
import type { SnapshotFormSchema } from '../../_model/snapshot';

type FormValues = z.infer<typeof SnapshotFormSchema>;

type DrawerState =
  | { open: false }
  | {
      open: true;
      isEditing: true;
      initialValues: Partial<FormValues>;
      id: string;
    }
  | {
      open: true;
      isEditing: false;
      initialValues?: never;
      id?: never;
    };

const Context = createContext<
  | {
      drawerState: DrawerState;
      setDrawerState: Dispatch<SetStateAction<DrawerState>>;
    }
  | undefined
>(undefined);

export const useSnapshotDrawerState = () => {
  const context = useContext(Context);
  if (!context) {
    throw new Error('useDrawerState must be used within DrawerProvider.');
  }
  return context;
};

export const SnapshotDrawerStateProvider: FC<PropsWithChildren> = ({
  children,
}) => {
  const [drawerState, setDrawerState] = useState<DrawerState>({ open: false });

  return (
    <Context.Provider value={{ drawerState, setDrawerState }}>
      {children}
    </Context.Provider>
  );
};
